import getCurrentAccountInfo from './getCurrentAccountInfo';
import updateGuideVersion from './updateGuideVersion';

export default {
    /** 获取新手引导版本 */
    getCurrentAccountInfo,
    /** 修改新手引导版本 */
    updateGuideVersion,
};


// WEBPACK FOOTER //
// ./src/api/guide/index.ts